var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgJobspaceIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 100 100",
    width: 100,
    height: 100,
    role: "img",
    "aria-label": "JobSpace search mark",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "glass",
    fill: "none"
  }, /*#__PURE__*/React.createElement("line", {
    id: "handle",
    x1: 58.97,
    y1: 58.97,
    x2: 86,
    y2: 86,
    stroke: "#1AAA55",
    strokeWidth: 11,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "lens",
    cx: 42,
    cy: 42,
    r: 24,
    stroke: "#1AAA55",
    strokeWidth: 11
  }), /*#__PURE__*/React.createElement("g", {
    id: "seeker",
    fill: "#1AAA55",
    stroke: "none"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 42,
    cy: 36.46,
    r: 5.54
  }), /*#__PURE__*/React.createElement("path", {
    d: "M34.15 54.00 C 34.15 42.92 49.85 42.92 49.85 54.00 Z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgJobspaceIcon);
export default __webpack_public_path__ + "static/media/jobspace-icon.30bbb4cb278ab0df74c15e86f6ae1965.svg";
export { ForwardRef as ReactComponent };